

export default function authHeader() {
  const currentUser = localStorage.getItem("token");
  if (currentUser)
    return {
      Authorization: `Bearer ${currentUser}`,
    };
  return {};
}
